export default "__VITE_ASSET__VwO4kDtv__"